import './SpeedometerChart.scss';

import { number, string } from 'prop-types';
import React from 'react';

class SpeedometerChart extends React.Component {
  componentDidMount() {
    const { percentChange } = this.props;
    percentAnimation(percentChange);
  }
  render() {
    const { percentChange, textX, text } = this.props;
    percentAnimation(percentChange);
    return (
      <svg height="150" width="200" viewBox="0 0 200 200">
        <path className="bg" d="M41 149.5a77 77 0 1 1 117.93 0" fill="none" />
        <path
          className="meter"
          d="M41 149.5a77 77 0 1 1 117.93 0"
          fill="none"
          strokeDasharray="350"
          strokeDashoffset="350"
        />
        {text && (
          <text className="donut-text" x={textX} y="100">
            {text}
          </text>
        )}
      </svg>
    );
  }
}

SpeedometerChart.propTypes = {
  percentChange: number.isRequired,
  textX: number,
  text: string
};

const percentAnimation = (percentChange) => {
  const meters = document && document.querySelectorAll('svg .meter');
  if (meters.length) {
    const path = meters[0];
    const length = path.getTotalLength();
    const to =
      percentChange === 0 ? 350 : length * ((100 - percentChange) / 100);
    path.getBoundingClientRect();
    // Set the Offset
    path.style.strokeDashoffset = Math.max(0, to);
  }
};

export default SpeedometerChart;
